<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">

    	<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
	        <el-form-item style="width:12%">
	            <el-date-picker v-model="query.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="isselect=true"></el-date-picker>
	        </el-form-item>
	        <el-form-item style="width:12%">
	            <el-date-picker v-model="query.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="isselect=true"></el-date-picker>
	        </el-form-item>
	        <el-form-item>
	        	<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
	        	<el-button round size="mini" class="menubutton" @click="getsalestypedata(1)">今日</el-button>
	        	<el-button round size="mini" class="menubutton" @click="getsalestypedata(2)">昨日</el-button>
	        	<el-button round size="mini" class="menubutton" @click="getsalestypedata(3)">本月</el-button>
	        	<el-button round size="mini" class="menubutton" @click="getsalestypedata(4)">本年</el-button>
	  		</el-form-item>
	  	</el-form>
	  	
	  	<!----------资产------------------>
	  	<div class="salesmain" style="margin-top:10px" v-loading="saleLoading">
	  		<div class="bordertitle"><img src="../../static/images/saleicon1.png"/><span>销售情况</span></div>
	  		<div class="bordermain">
	  			<div class="single" style="border-right:1px solid #EBEEF5">
				  	<el-tooltip placement="top">
						<div slot="content">当前系统剩余商品库存总金额（平均成本价*剩余数量）<br/></div>
	  					<span>{{sales.all.amount}} <i>{{sales.all.unit}}</i></span>
					</el-tooltip>
	  				<p>剩余库存总金额</p>
	  			</div>
	  			<div class="single" style="border-right:1px solid #EBEEF5">
				  	<el-tooltip placement="top">
						<div slot="content">指定时间内进货入库单（状态：已完成）的订单金额合计</div>
	  					<span>{{sales.storage.amount}} <i>{{sales.storage.unit}}</i></span>
					</el-tooltip>
	  				<p>进货库存</p>
	  			</div>
	  			<div class="single" style="border-right:1px solid #EBEEF5">
				  	<el-tooltip placement="top">
						<div slot="content">指定时间内盘盈入库商品总金额合计（商品平均成本价*盘盈数量）</div>
	  					<span>{{sales.stockinventory.amount}} <i>{{sales.stockinventory.unit}}</i></span>
					</el-tooltip>
	  				<p>盘盈库存</p>
	  			</div>
	  			<div class="single">
				    <el-tooltip placement="top">
						<div slot="content">指定时间内退货单金额合计（商品进货价*数量）</div>
	  					<span>{{sales.refund.amount}} <i>{{sales.refund.unit}}</i></span>
					</el-tooltip>
	  				<p>退货库存</p>
	  			</div>
	  		</div>
	  	</div>
	  	
	  	<!---------收款情况------------->
	  	<div class="salesmain" style="margin-top:10px" v-loading="salecostLoading">
	  		<div class="bordertitle"><img src="../../static/images/saleicon1.png"/><span>负债</span></div>
	  		<div class="bordermain">
	  			<div class="single" style="border-right:1px solid #EBEEF5">
				  	<el-tooltip placement="top">
						<div slot="content">截止当前时间客户预存款剩余金额合计</div>
	  					<span>{{salescost.balance.amount}} <i>{{salescost.balance.unit}}</i></span>
					</el-tooltip>
	  				<p>剩余预存款金额</p>
	  			</div>
	  			<div class="single">
				  	<el-tooltip placement="top">
						<div slot="content">截止当前时间应付供应商货款金额合计<br>（已完成进货入库订单金额合计，<br/>包含有供应商、无供应商的进货入库单）</div>
	  					<span>{{salescost.selltotal.amount}} <i>{{salescost.selltotal.unit}}</i></span>
					</el-tooltip>
	  				<p>应付帐款金额</p>
	  			</div>
	  		</div>
	  	</div>
	  	
	  	
    	    	
    </div>
    </transition>
</template>

<script>

export default {
    data () {
	    return {
	        url:this.GLOBAL.domain+"Datastat/index",
	        transitionshow:true,
	        actionauth:[],
	        query: {
	        	act:'balancesale',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        saleLoading:false,
	        sales:[],
	        costquery: {
	        	act:'balancecost',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        salecostLoading:false,
	        salescost:[],
	        
	    }
    },
    
    mounted(){
  		this.getactionauth(); //获取权限设置
  		this.getbalancesale(); //销售情况
  		this.getbanlancecost(); //欠款情况
    },
    
    methods:{    
	    /** 获取操作功能权限 **/
	  	getactionauth() {
	    	var data =this.$cookies.get('actionauth');
	    	data=JSON.parse(data);
	        this.actionauth=data;
	    },
	    
	    
	    /** 获取今日、昨日、本月、本年数据 **/
	    getsalestypedata(type) {
	    	if(type==1) { //今日
	    		var nowday=new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate();  		   		
	    		this.query.start=nowday;
	    		this.query.end=nowday;
	    		
	    	}else if(type==2) { //昨日
	    		var myday=new Date(new Date() - 1000*60*60*24);
	    		var yesterday=myday.getFullYear().toString()+'-'+(myday.getMonth()+1)+'-'+myday.getDate();
	    		this.query.start=yesterday;
	    		this.query.end=yesterday;
	    	
	    	}else if(type==3) { //本月
	    		var nowDate = new Date();
				var cloneNowDate = new Date();
				var fullYear = nowDate.getFullYear();
				var month = nowDate.getMonth() + 1; // getMonth 方法返回 0-11，代表1-12月
				var endOfMonth = new Date(fullYear, month, 0).getDate(); // 获取本月最后一天
				var starDate = this.getFullDate(cloneNowDate.setDate(1));//当月第一天
				var endDate = this.getFullDate(cloneNowDate.setDate(endOfMonth));//当月最后一天
				this.query.start=starDate;
	    		this.query.end=endDate;
	    	
	    	}else if(type==4) { //本年
	    		var nowDate = new Date();
	    		var start=nowDate.getFullYear()+"-"+"01"+"-"+"01";
	    		var end=nowDate.getFullYear()+"-"+"12"+"-"+"31";
	    		this.query.start=start;
	    		this.query.end=end;
	    	}
	    
	    	this.getbalancesale(); //获取资产负债，销售情况
	    	this.getbanlancecost(); //获取资产负债，应付账款金额
	    },
	    
	    getFullDate(targetDate) {
	        var D, y, m, d;
	        if (targetDate) {
	            D = new Date(targetDate);
	            y = D.getFullYear();
	            m = D.getMonth() + 1;
	            d = D.getDate();
	        } else {
	            y = fullYear;
	            m = month;
	            d = date;
	        }
	        m = m > 9 ? m : '0' + m;
	        d = d > 9 ? d : '0' + d;
	        return y + '-' + m + '-' + d;
	    },
	    
	    search() {
	    	this.getbalancesale(); //获取资产负债，销售情况
	    	this.getbanlancecost(); //获取资产负债，应付账款金额
	    },
	    
	    
	    /** 资产负债，销售情况 **/
	    getbalancesale() {
	    	this.saleLoading=true;
	    	var resource = this.$resource(this.url);
	        resource.query(this.query).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.saleLoading=false;
		        }else{
		            this.sales = JSON.parse(Base64.decode(res.data.Data));
		            this.saleLoading=false;
		        }
	        }).catch((res) => {
	            this.saleLoading=false;
	        });	
	    },
	    
	    /** 资产负债，欠债 **/
	    getbanlancecost() {
	    	this.costquery.start=this.query.start;
     		this.costquery.end=this.query.end;
	    
	    	this.salecostLoading=true;
	    	var resource = this.$resource(this.url);
	        resource.query(this.costquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.salecostLoading=false;
		        }else{
		            this.salescost = JSON.parse(Base64.decode(res.data.Data));
		            this.salecostLoading=false;
		        }
	        }).catch((res) => {
	            this.salecostLoading=false;
	        });	
	    },
     
    }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.menubutton:focus, .menubutton:hover {color:#fff;border-color:#409EFF;background-color:#409EFF}
.salesmain {padding:2% 2% 2% 2%;background:#fff;border-radius:5px;float:left;width:96%;}
.bordertitle {float:left;width:100%;}
.bordertitle img {float:left;width:4%;}
.bordertitle span {float:left;font-size:16px;margin-left:1%;padding:0.6% 0 0.6% 0;color:#606266;}
.bordermain {float:left;width:100%;}
.bordermain .single {float:left;width:18%;text-align:center;}
.bordermain .single span {float:left;width:100%;font-size:20px;text-align:center;font-weight:bold;color:#F56C6C;margin-top:10%}
.bordermain .single span i {font-size:14px;font-style:normal;}
.bordermain .single p {float:left;width:100%;text-align:center;font-size:14px;color:#909399;margin-top:3%}
.bordermain .double {float:left;width:18%;padding:0 1% 0 1%;text-align:center;background:#E4E7ED}
.bordermain .double table {float:left;width:100%;padding:10% 0 8% 0}
.bordermain .double table td {font-size:14px;color:#909399;}
.firstcustomer {font-style:normal;padding:2px 5px 2px 5px;border-radius:15px;color:#67C23A;background:#DCDFE6}
.secondcustomer {font-style:normal;padding:2px 5px 2px 5px;border-radius:15px;color:#E6A23C;background:#DCDFE6}
.double p {float:left;width:100%;margin-top:10%;text-align:center;font-size:14px;color:#909399}
.double p i {font-style:normal;color:#606266}
.percent {float:left;margin-top:3%;border-radius:15px;width:70%;height:10px;margin-bottom:8%;background:#C0C4CC}
.percent h {float:left;height:100%;background:#E6A23C;border-radius:15px}
.double em {font-style:normal;color:#606266;font-size:14px;float:left;line-height:22px;margin-left:5%}

</style>


// WEBPACK FOOTER //
// src/components/stat/Debt.vue